import { useEffect } from "react";

export default function usePageMeta(title, description) {
  useEffect(() => {
    document.title = title;
    if (description) {
      const m = document.querySelector('meta[name="description"]');
      if (m) m.setAttribute("content", description);
    }
    window.scrollTo(0, 0);
  }, [title, description]);
}

export function useJsonLd(data) {
  useEffect(() => {
    if (!data) return;
    document.getElementById("dynamic-jsonld")?.remove();
    const s = document.createElement("script");
    s.type = "application/ld+json";
    s.id = "dynamic-jsonld";
    s.text = JSON.stringify(data);
    document.head.appendChild(s);
  }, [data]);
}
